// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form.guest-name-dialog[data-v-c1266f5a]{display:flex;max-width:200px;margin:auto;margin-top:-2px;padding:3px}form.guest-name-dialog[data-v-c1266f5a] img{margin:0 !important}form.guest-name-dialog input[type=text][data-v-c1266f5a]{flex-grow:1}form.guest-name-dialog label[data-v-c1266f5a]{padding:3px;height:32px}\n", ""]);
// Exports
module.exports = exports;
